import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function atLeastOneRequiredTrueValidator(field1: string, field2: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const group = control as any; // Treat the control as a FormGroup
    const value1 = group.get(field1)?.value;
    const value2 = group.get(field2)?.value;

    if ((value1 || value2) === null || (value1 === "" && value2 === "") || (value1 === false && value2 === false)) {
      return { atLeastOneRequired: true }; // Return error if both fields are empty
    }
    return null; // Valid if at least one field has a value
  };
}
